<template>
	<div class="ks-videoeditor-sources">
		<k-tabs grow v-model="source_tab">
			<k-tab name="events" label="Event clips"></k-tab>
			<k-tab name="content" label="Content"></k-tab>
		</k-tabs>

		<event-sources
			v-show="source_tab == 'events'"
			:event_uuid="event_uuid"
			@opened="source_tab = 'events'"
			@add-clip="$emit('add-clip', $event)"></event-sources>
		<content-sources
			v-show="source_tab == 'content'"
			@add-clip="$emit('add-clip', $event)"
			@add-overlay="$emit('add-overlay', $event)"
			@add-audio="$emit('add-audio', $event)"></content-sources>
	</div>
</template>

<script>
import ContentSources from './ContentSources.vue'
import EventSources from './EventSources.vue'

// Left panel: lists the media that can be added to the timeline. Emits add-clip, add-overlay and add-audio.
export default {
	components: {ContentSources, EventSources},
	props: {
		event_uuid: String
	},
	data () {
		return {
			source_tab: "events"
		}
	}
}
</script>
